import { post, get, patch, deleteRequest } from "./restApi";

export const getMyInstallationOrders = (payload) => {
    return post("my-installation-orders/get-list", payload);
}
export const rejectionInstallationOrderAssignUser = (payload) => {
    return post("my-installation-orders/rejection", payload);
}
export const acceptInstallationOrderAssignUser = (payload) => { 
    return post("my-installation-orders/accept", payload);
}
export const getInstallationOrderAssignUsersByIdPopulate = (id) => {
    return get(`my-installation-orders/detail/${id}`);
}
export const completedInstallationOrderAssignUser = (payload) => {
    return patch("my-installation-orders/completed", payload);
}
export const updateInstallationOrderAssignUser = (payload) => {
    return patch("my-installation-orders/update-installation-order", payload);
}